import { MAIN_TEXT_COLOR } from "shared/consts";
import styled, { css } from "styled-components";

interface TableItemProps {
  $active?: boolean;
  $pen?: boolean
}

export const TableItem = styled.div<TableItemProps>`
  display: flex;
  flex-direction: column;
  justify-content:center;align-items: center;
  gap: 2px;
  padding: 6px;
  aspect-ratio: 48 / 50;
  line-height: 1.2;
  border-radius: 12px;
  cursor: pointer;
  ${props => props.$pen && css`pointer-events: none`};


  ${props => {
    if (props.$active) {
      return `
        color: #fff;
        background-color: ${MAIN_TEXT_COLOR};
        span {
          &:last-child{
            font-size: 14px;
          }
        }
      `
    } else {
      return `
        background-color: #fff;
        box-shadow: 0px 4px 8px 0px rgba(44, 60, 108, 0.1);
        span {
          &:last-child{
            font-size: 14px;
            color: ${MAIN_TEXT_COLOR};
          }
        }
      `
    }
    return ''
  }}
`